export default function BlockDropIcon() {
  // Jelly-buddy blocks: puffy rounded cells with little faces, in the game's own candy palette.
  const b = (x: number, y: number, c: string, d: string, face = false) => (
    <g key={`${x}-${y}`}>
      <rect x={x} y={y} width="13" height="13" rx="5" fill={c} stroke={d} strokeWidth="1.5" />
      <ellipse cx={x + 4} cy={y + 3.5} rx="2" ry="1.2" fill="#fff" opacity="0.6" />
      {face && (
        <>
          <circle cx={x + 4.6} cy={y + 6.6} r="1" fill={d} />
          <circle cx={x + 8.4} cy={y + 6.6} r="1" fill={d} />
          <path d={`M${x + 4.8} ${y + 8.6} Q${x + 6.5} ${y + 10.4} ${x + 8.2} ${y + 8.6}`} stroke={d} strokeWidth="1" fill="none" strokeLinecap="round" />
        </>
      )}
    </g>
  );
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="2" width="56" height="60" rx="8" fill="#1a1440" />
      {b(25, 6, '#ffae3d', '#8a4c00')}
      {b(12, 19, '#ffae3d', '#8a4c00')}
      {b(25, 19, '#ffae3d', '#8a4c00', true)}
      {b(38, 19, '#ffae3d', '#8a4c00')}
      {b(8, 46, '#ff6fae', '#9c2a5e', true)}
      {b(21, 46, '#4fd99a', '#16784c')}
      {b(21, 33, '#4fd99a', '#16784c', true)}
      {b(34, 46, '#3ec4ff', '#0d6a96')}
      {b(34, 33, '#b28cff', '#5a37a8', true)}
      {b(47, 33, '#b28cff', '#5a37a8')}
      {b(47, 46, '#ffe14d', '#8f7a00', true)}
    </svg>
  );
}
